import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { BATCH_ACTIONS } from './BatchDetailsInformationHeader';
import { IModalWindow, MODAL_TYPE, ModalWindow } from '../modal/ModalWindow';
import { BatchActionModalContent } from './BatchActionModalContent';
import { batchAction } from '../../store/order/actions/batches';
import { fetchUnpostedBatchData } from '../../store/payments/actions/batches';
import { IBatchesFiltersParams } from './BatchesFilterSection';
import { parseSearchParams } from '../../utils/utilities';
import { useLocation } from 'react-router';
import { usePaymentContext } from '../../store/payments/payments-context';

interface Props {
  buttonName: string;
  isDisabled: boolean;
  batchId: string;
  action: BATCH_ACTIONS;
}

export const BatchTableActionButton: FC<Props> = (props) => {
  const { buttonName, isDisabled, batchId, action } = props;

  const { t } = useTranslation();
  const { search } = useLocation();

  const { dispatch } = usePaymentContext();


  const [modalState, setModalState] = useState<IModalWindow>({ isOpen: false });
  const [batchModalState, setBatchModalState] = useState({
    isOpen: false,
    batchId: '',
    action: null
  });

  const filtersFromUrl: IBatchesFiltersParams = parseSearchParams(search) || {};

  const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

  const closeBatchModal = (): void => setBatchModalState({ isOpen: false, batchId: '', action: null });

  const postSuccessModalAction = async (): Promise<void> => {
    closeModal();
    await fetchUnpostedBatchData({ dispatch, params: filtersFromUrl });
  };

  const handlePostSuccess = (): void => {
    closeBatchModal();
    setModalState({
      isOpen: true,
      modalType: MODAL_TYPE.APPROVE,
      modalTitle: t('PENDING_PAYOUTS.MODAL_TITLE_POST'),
      modalText: 'The batch has been successfully posted.',
      confirmButtonText: 'Ok',
      onConfirm: postSuccessModalAction,
      onClose: postSuccessModalAction,
    });
  };


  return (
    <>
      <ButtonComponent
        buttonType={BUTTON_TYPE.WHITE}
        buttonName={t(buttonName)}
        onButtonClick={(): void => setBatchModalState({
          isOpen: true,
          batchId,
          action,
        })}
        isDisabled={isDisabled}
        additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 d-block"
      />

      <ModalWindow
        {...modalState}
      />

      <ModalWindow
        isOpen={batchModalState?.action === BATCH_ACTIONS.POST && batchModalState.isOpen}
        modalType={MODAL_TYPE.SAVE}
        modalTitle={t('PENDING_PAYOUTS.MODAL_TITLE_POST')}
        backdrop='static'
        content={<BatchActionModalContent />}
        onCancel={closeBatchModal}
        onClose={closeBatchModal}
        onConfirm={(): Promise<void> => batchAction({
          batchId: batchModalState.batchId,
          action: batchModalState?.action,
          onSuccess: handlePostSuccess,
          onClose: closeBatchModal,
        })}
      />
    </>
  );
};